const collections = ["blog", "case-studies", "ebooks-webinars"];

const collectionsSettings = collections.map((collection) => {
  return {
    name: collection,
    label: collection,
    folder: `content/${collection}`,
    slug: "{{year}}-{{month}}-{{day}}-{{title}}",
    create: true,
    i18n: true,
    sortable_fields: ["publishedAt", "title"],
    identifier_field: "slug",
    fields: [
      {
        label: "Title",
        name: "title",
        widget: "string",
        i18n: true,
      },
      {
        label: "Publication date",
        name: "publishedAt",
        widget: "date",
        dateFormat: "YYYY-MM-DD",
        i18n: "duplicate",
      },
      {
        label: "Status",
        name: "status",
        widget: "select",
        options: ["draft", "published"],
        default: "draft",
        i18n: true,
      },
      {
        label: "Slug (Caution! changes the URL of the Article)",
        name: "slug",
        widget: "slug",
        i18n: "duplicate",
      },
      {
        label: "Categories (comma separated)",
        name: "categories",
        widget: "list",
        i18n: true,
      },
      {
        label: "Cover image",
        name: "coverImage",
        widget: "image",
        i18n: true,
      },
      {
        label: "Headline",
        name: "headline",
        widget: "markdown",
        required: false,
        i18n: true,
      },
      {
        label: "Body",
        name: "body",
        widget: "markdown",
        i18n: true,
      },
    ],
  };
});

const config = {
  cms_manual_init: true,
  backend: {
    name: "github",
    repo: "Fluicity/fluicity-website",
    branch: "master",
  },
  editor: {
    preview: false,
  },
  media_folder: "public/images",
  public_folder: "/images",
  collections: collectionsSettings,
  i18n: {
    structure: "multiple_folders",
    locales: ["fr", "en"],
    default_locale: "fr",
  },
};

export default config;
